export class TachesUtilisateur {
  constructor(public idUtilisateur: number, public taches: (Tache | TacheSaveModel)[] = []) {}

}

export class TacheEtatUtilisateurCount {
  etat: EtatTache;
  count: number;
}

export enum TypeLien {
  indefini,
  personne,
  formateur,
  entreprise,
  session,
  personnel,
}

export interface LienTache {
  typeLien: TypeLien;
  idLien: number;
  libelle: string;
  idOriginal: number;
  isRedirectionDisabled: boolean;
  isSuppressionDisabled: boolean;
}

class TacheBase {
  id: number;
  titre: string;
  description: string;
  dateCreation: Date;
  dateModification?: Date;
  guidUtilisateurCreation?: string;
  guidUtilisateurModification?: string;
  date: Date;
  heureDebut: string;
  heureFin: string;
  etat: EtatTache;
  dateTerminaison: Date;
  idCategorie: number;
}

export class Tache extends TacheBase {
  constructor() { super(); this.liens = []}
  liens: LienTache[]

  static estTerminee(tache: TacheBase) {
    return tache.etat == EtatTache.Termine
  }
}

export enum EtatTache {
  AFaire = 1,
  EnCours = 2,
  Termine = 3
}

export class TacheSaveModel extends TacheBase {
  constructor() { super(); this.liens = []}
  liens: number[]
}

export class TypeLienVisuel {
  libelle: string;
  typeId: number;
  iconClass: string;
}
